module.exports = __webpack_public_path__ + "media/images/athletes/2894-c0457b05d98d1487ea9912aecf8cb595.png";